window.addEventListener("DOMContentLoaded", function() { 


    if (document.querySelector('.backToTopBtn')) {

        const backToTopBtn = document.querySelector('.backToTopBtn')

        window.addEventListener('scroll', () => {
            if(window.scrollY > 600) {
                backToTopBtn.classList.remove('displayNone')
            } else {
                backToTopBtn.classList.add('displayNone')
            }
        })
    

        backToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,                
                behavior: 'smooth'
            })
        })

    }

});
